import {
  AudioOutlined,
  CodeOutlined,
  EyeOutlined,
  MessageOutlined,
  ClusterOutlined,
  PictureOutlined,
  ToolOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";

/* Shared presentation helpers for the model directory. Both surfaces —
   the public /models page and the console 模型 directory — render the
   same catalog, so capability metadata and the number formatters live
   here rather than being duplicated per page. */

/* Capability class → icon + bilingual label. Classes outside the map
   fall back to a neutral tag so unknown data is still visible. */
export const CAP_META: Record<string, { icon: React.ReactNode; zh: string; en: string; hint: string }> = {
  chat:      { icon: <MessageOutlined />,      zh: "对话",   en: "Chat",      hint: "对话补全 / Chat completions" },
  tools:     { icon: <ToolOutlined />,          zh: "工具",   en: "Tools",     hint: "函数 / 工具调用 / Tool calling" },
  embedding: { icon: <ClusterOutlined />,       zh: "向量",   en: "Embedding", hint: "文本向量化 / Embeddings" },
  image:     { icon: <PictureOutlined />,       zh: "图像",   en: "Image",     hint: "图像生成 / Image generation" },
  audio:     { icon: <AudioOutlined />,         zh: "语音",   en: "Audio",     hint: "语音输入输出 / Speech" },
  video:     { icon: <VideoCameraOutlined />,   zh: "视频",   en: "Video",     hint: "视频生成 / Video generation" },
  vision:    { icon: <EyeOutlined />,           zh: "视觉",   en: "Vision",    hint: "图像理解 / Visual understanding" },
  code:      { icon: <CodeOutlined />,          zh: "代码",   en: "Code",      hint: "代码补全 / Code completion" },
};

export function formatContext(tokens?: number): string {
  if (!tokens) return "—";
  if (tokens >= 1_000_000) {
    const m = tokens / 1_000_000;
    return `${m % 1 === 0 ? m : m.toFixed(1)}M`;
  }
  return `${Math.round(tokens / 1000)}K`;
}

export function formatPrice(perMillion?: number | null): string {
  if (perMillion == null) return "—";
  const usd = perMillion / 1_000_000;
  if (usd === 0) return "$0";
  if (usd < 1) return `$${usd.toFixed(2).replace(/0$/, "")}`;
  return `$${usd.toFixed(2).replace(/\.00$/, "")}`;
}
